export default "__VITE_ASSET__91900c51__"